import { render } from "./person-nationality-update.vue?vue&type=template&id=f0b8e6ae"
import script from "./person-nationality-update.vue?vue&type=script&lang=js"
export * from "./person-nationality-update.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__